import {createSelector} from "@reduxjs/toolkit";
import {indexesOf, ReducerStatuses} from "services/utils/utils";
import {flattenDeep, keyBy, sortBy} from "lodash";

const baseState = state => state.comments.comment;

export const commentDataSelector = createSelector([baseState], (state) => {
    return state.comment;
});
export const commentShowAttachmentModalSelector = createSelector([baseState], (state) => {
    return state.show_attachment_modal;
});
export const commentLoadingSelector = createSelector([baseState], (state) => {
    return state.status === ReducerStatuses.LOADING;
});
export const commentErrorSelector = createSelector([baseState], (state) => {
    return {
        inError: state.status === ReducerStatuses.ERROR,
        error: state.error
    };
});
export const commentServerDataSelector = createSelector([baseState], (state) => {
    const comment = state.comment;
    const tags = state.tags;
    if(tags.length === 0) {
        return {
            comment: comment,
            tags: []
        };
    }
    const keys = Array.from(new Set(tags.map(i => i.key)));
    const keys_object = keyBy(tags, "key");
    const regex = new RegExp(`${keys.join("|")}`, "g");
    const indexes = indexesOf(comment, regex);
    const remap = flattenDeep(Object.entries(indexes).map(([key, values]) => {
        return values.map(i => ({key, index: i, id: keys_object[key].id}));
    }))
    const user_ids_ordered = sortBy(remap, 'index').map(i => i.id);
    return {
        comment: comment.replace(regex, "$TAG"),
        tags: user_ids_ordered
    }
});